// Enhanced color scheme with better contrast and accessibility
export const CHART_COLORS = {
  greenCharging: "#10b981", // Modern green - more vibrant
  aiOptimization: "#3b82f6", // Modern blue - better contrast
  userSchedules: "#8b5cf6", // Modern purple - more readable
  powerConsumed: "#f59e0b", // Modern amber - warmer tone
  powerOffered: "#06b6d4", // Modern cyan - more distinct
  gridBackground: "#f8fafc", // Light background
  gridLines: "#e2e8f0", // Subtle grid lines
  textPrimary: "#1e293b", // Dark text for better readability
  textSecondary: "#64748b", // Secondary text
};

export const CHART_COLORS_DARK = {
  ...CHART_COLORS,
  gridBackground: "#0f172a",
  gridLines: "#334155",
  textPrimary: "#e2e8f0",
  textSecondary: "#94a3b8",
};

export const CHART_TITLE = "Schedules and Energy Consumption";

export const FONT_FAMILY = "system-ui, -apple-system, sans-serif";

export const MARGIN = { top: 10, right: 20, bottom: 70, left: 75 };

export const SERIES_CONFIG = [
  {
    key: "greenChargingSetpointPower",
    name: "Green Charging",
    color: CHART_COLORS.greenCharging,
    lineWidth: 2.5,
    stepLeft: true,
    zIndex: 3,
    dashed: false,
    isSetpoint: true,
  },
  {
    key: "smartChargingSetpointPower",
    name: "AI optimization",
    color: CHART_COLORS.aiOptimization,
    lineWidth: 2.5,
    stepLeft: true,
    zIndex: 3,
    dashed: false,
    isSetpoint: true,
  },
  {
    key: "userSetSchedulesSetpointPower",
    name: "User Set Schedules",
    color: CHART_COLORS.userSchedules,
    lineWidth: 2.5,
    stepLeft: true,
    zIndex: 3,
    dashed: false,
    isSetpoint: true,
  },
  {
    key: "energyConsumptionData",
    name: "Power Consumed",
    color: CHART_COLORS.powerConsumed,
    lineWidth: 2,
    stepLeft: false,
    zIndex: 2,
    dashed: false,
    isSetpoint: false,
  },
  {
    key: "powerOffered",
    name: "Power Offered",
    color: CHART_COLORS.powerOffered,
    lineWidth: 2,
    stepLeft: false,
    zIndex: 1,
    dashed: true,
    isSetpoint: false,
  },
];

export const Y_AXIS_PADDING_MULTIPLIER = 1.1;
export const X_AXIS_LABEL_OFFSET = 40;
export const Y_AXIS_LABEL_OFFSET = 60;
export const TOOLTIP_BOTTOM_PADDING = 5;
export const BACKGROUND_BORDER_RADIUS = 8;
